import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import { mediaVideo1 } from '../../../assets/images';

const MediaItems = () => {
  const { i18n } = useTranslation();
  const currentLanguage = i18n.language;

  const media = [
{
"id": 1,
"title": "Qubadlı rayonunun Zilanlı və Mahruzlu kəndlərində əsas və təsərrüfat yollarında qazıntı işləri, şaquli və üfüqi planlama işləri uğurla icra olunmuşdur.",
"titleRu": "Успешно завершены земляные работы, работы по вертикальному и горизонтальному планированию основных и сельских дорог в селах Зиланли и Махрузлу Губадлиского района.",
"titleEn": "Excavation works, vertical and horizontal planning works on main and farm roads in the villages of Zilanli and Mahruzlu of the Gubadli district were successfully carried out.",
"video": mediaVideo1,
},
  ]

  const getLocalizedField = (item, fieldBase) => {
    if (!item) return '';
    if (currentLanguage === 'en') return item[`${fieldBase}En`] || item[fieldBase];
    if (currentLanguage === 'ru') return item[`${fieldBase}Ru`] || item[fieldBase];
    return item[fieldBase]; // default: az
  };

  return (
    <div className='pt-[56px] md:pt-[88px] bg-[#F9F9F9] font-secondFont'>
      <div className='max-w-containerSm md:max-w-container mx-auto grid grid-cols-1 md:grid-cols-4 gap-x-5 gap-y-8'>
        {media.map((item) => (
           <div className='group overflow-hidden rounded-lg'>
              <div className="relative overflow-hidden rounded-lg">
  <video
    src={item.video}
    className="w-full h-[250px] object-cover transition-transform duration-300"
    controls
    muted
  />
</div>
              <p className='mt-3 text-[#1C1C1C]'>
                {getLocalizedField(item, "title")?.replace(/<[^>]*>/g, '')}
              </p>
            </div>
        ))}
      </div>
    </div>
  );
};

export default MediaItems;
